module.exports = __webpack_public_path__ + "img/treeplant1_7-8-2021.aa5683c2.jpg";